import {PlusIcon} from '@heroicons/react/16/solid';
import {Link} from 'react-router-dom';
import {PAYMENT_CARD_SIZE_CLASS} from '../../../../../components/specific/CreditCard';

const TILE_CLASS =
    `${PAYMENT_CARD_SIZE_CLASS} flex items-center justify-center rounded-[18px] border-2 border-dashed border-gray-200 bg-gray-50 transition hover:border-gray-300 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50`;

type Props = {title: string} & (
    | {to: string}
    | {onClick: () => void; disabled?: boolean}
);

export function AddCardTile(props: Props) {
    const icon = <PlusIcon className="h-10 w-10 text-gray-400" />;

    if ('to' in props) {
        return (
            <Link title={props.title} to={props.to} className={TILE_CLASS}>
                {icon}
            </Link>
        );
    }

    return (
        <button
            type="button"
            title={props.title}
            onClick={props.onClick}
            disabled={props.disabled}
            className={TILE_CLASS}
        >
            {icon}
        </button>
    );
}
